import { useEffect } from 'react';

import styles from './BusinessPlan.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DocumentUploadSection from '../components/DocumentUploadSection/DocumentUploadSection';

const DOCUMENT_TYPE = 'business plan';
const listOfInstructions = [
  'The business you are proposing',
  'How you plan on generating revenue',
  'The size of investment you need',
  'How the funds will be used',
  'Details of your experience in the industry',
];

type TProps = {
  isActive: boolean;
  isError?: boolean;
  onRequestUpload: () => void;
};

const BusinessPlan = ({ isActive, isError, onRequestUpload }: TProps) => {
  const stateKey = useContextStateKey();
  const { documents } = useGetDocuments(stateKey);

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  useEffect(() => {
    if (documents) {
      const businessPlanDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(businessPlanDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DocumentUploadSection
        documentType={DOCUMENT_TYPE}
        description="Include information on:"
        listOfInstructions={listOfInstructions}
        uploadedFiles={uploadedFiles}
        isActive={isActive}
        isError={isError}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
        removeFile={removeFile}
        onRequestUpload={onRequestUpload}
      />
    </div>
  );
};

export default BusinessPlan;
